import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#getToastId">getToastId(properties)</a></dt>
      <dd>
        <p>{`Generates an identifier for a toast by inspecting the properties that
differentiate toasts from one another.`}</p>
      </dd>
      <dt><a href="#useToasts">useToasts()</a> ⇒ <inlineCode>Array.&lt;Object&gt;</inlineCode></dt>
      <dd>
        <p>{`A hook that provides access to the toast state and toast api.`}</p>
      </dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#ToastProps">ToastProps</a></dt>
      <dd>
        <p>{`Object containing data for creating toasts using `}<a parentName="p" {...{
            "href": "#API.addToast"
          }}>{`addToast`}</a>{`.`}</p>
      </dd>
      <dt><a href="#API">API</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`The API for managing toasts.
Use this API to add and remove toasts.`}</p>
      </dd>
    </dl>
    <p>{`Generates an identifier for a toast by inspecting the properties that
differentiate toasts from one another.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`properties`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode></inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A composite identifier object with properties   that identify a specific toast using its `}<a parentName="td" {...{
              "href": "#ToastProps"
            }}>{`ToastProps`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`properties.type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode></inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Maps to the `}<inlineCode parentName="td">{`type`}</inlineCode>{` property of `}<a parentName="td" {...{
              "href": "#ToastProps"
            }}>{`ToastProps`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`properties.message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode></inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Maps to the `}<inlineCode parentName="td">{`message`}</inlineCode>{` property of `}<a parentName="td" {...{
              "href": "#ToastProps"
            }}>{`ToastProps`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`properties.dismissable`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode>{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Maps to the `}<inlineCode parentName="td">{`dismissable`}</inlineCode>{` property of `}<a parentName="td" {...{
              "href": "#ToastProps"
            }}>{`ToastProps`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`properties.actionText`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode>{`'`}{`'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Maps to the `}<inlineCode parentName="td">{`actionText`}</inlineCode>{` property of `}<a parentName="td" {...{
              "href": "#ToastProps"
            }}>{`ToastProps`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`properties.icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`React.Element`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode>{`()`}{`=`}{`>`}{`{}`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Maps to the `}<inlineCode parentName="td">{`icon`}</inlineCode>{` property of `}<a parentName="td" {...{
              "href": "#ToastProps"
            }}>{`ToastProps`}</a></td>
        </tr>
      </tbody>
    </table>
    <p>{`A hook that provides access to the toast state and toast api.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`Array.<Object>`}</inlineCode>{`
— An array containing objects for the toast state and its API: [`}<a parentName="p" {...{
        "href": "../useToastContext#ToastState"
      }}>{`ToastState`}</a>{`, `}<a parentName="p" {...{
        "href": "#API"
      }}>{`API`}</a>{`]`}</p>
    <p>{`Object containing data for creating toasts using `}<a parentName="p" {...{
        "href": "#API.addToast"
      }}>{`addToast`}</a>{`.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`One of the following toast types: 'info', 'warning',   or 'error'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`message`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The message to display on the toast`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[dismissable]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates whether the toast is dismissable.   If `}<inlineCode parentName="td">{`onDismiss`}</inlineCode>{` is provided, this property is assumed to be true.   This property is optional when creating toasts.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[icon]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`React.Element`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The icon element to display.   This property is optional when creating toasts.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[onDismiss]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback invoked when a user clicks the   dismiss icon.   This property is optional when creating toasts.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[actionText]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text to display as a call to action.   This property is optional when creating toasts.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[hasDismissAction]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates whether the toast should have a   dismiss action with the same behavior as the dismiss icon.   This property is optional when creating toasts.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[dismissActionText]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Text to display as a call to dissmisAction.   This property is optional when creating toasts.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[onAction]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback invoked when a user clicks the action   text.   This property is optional when creating toasts.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[timeout]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Time, in ms, before the toast is automatically   dismissed.   If `}<inlineCode parentName="td">{`0`}</inlineCode>{` or `}<inlineCode parentName="td">{`false`}</inlineCode>{` is passed, the toast will not timeout.   This property is optional when creating toasts.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The API for managing toasts.
Use this API to add and remove toasts.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#API"
        }}>{`API`}</a>{` : `}<inlineCode parentName="li">{`Object`}</inlineCode>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#API.removeToast"
            }}>{`.removeToast(id)`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#API.addToast"
            }}>{`.addToast(toastProps)`}</a>{` ⇒ `}<inlineCode parentName="li">{`Number`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <p>{`Removes a toast from the toast store.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The id of the toast to remove`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Dispatches an add action. Includes all props passed along with a hash id
and a timeout id generated based on the incoming props.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`Number`}</inlineCode>{`
— id The key referencing the toast in the store`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`toastProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#ToastProps"
            }}><inlineCode parentName="a">{`ToastProps`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The object containing props for adding a toast.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/Toasts/useToasts.js"
      }}>{`pwa-studio/packages/peregrine/lib/Toasts/useToasts.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      